export default {
  search: ['请输入您要搜索的用户名', 'Please enter the username'],
  time: ['访问时间', 'Interview Time'],
  mode: ['模式', 'Mode'],
  adminMode: ['管理员', 'Admin'],
  staffMode: ['员工', 'Staff'],
  username: ['用户名', 'Username'],
  realname: ['称呼', 'Call'],
  path: ['访问路径', 'Path'],
  userinfo: ['用户详情', 'User Info'],
  controller: ['程序入口', 'Controller']
};
